import React from 'react'
import styled from '@emotion/styled'
import { CheckIcon, spacer } from 'stylist'

const BlurbWrapper = styled.div`
  margin: auto 0;
  line-height: 30px;

  .check {
    margin-right: ${spacer(3)};
    stroke-width: 3px;
  }
`

const ResultBlurb = ({ blurbs }) => (
  <BlurbWrapper>
    {blurbs
      ? blurbs.map((txt, index) => (
          <div key={index}>
            <CheckIcon className="check" size="m" />
            {txt}
          </div>
        ))
      : null}
  </BlurbWrapper>
)

export default ResultBlurb



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/results/ResultBlurb.js